export function customLink(value, image = false) {
  // Reject control characters before URL parsing can normalize them.
  // eslint-disable-next-line no-control-regex
  if(typeof value!=='string'||/[\x00-\x20\x7f\\]/.test(value.trim()))return '';
  const s=value.trim();if(!s||s.startsWith('//'))return '';
  if(!image&&/^(\/(?!\/)|#|\?)/.test(s))return s;
  try{const u=new URL(/^[a-z][a-z0-9+.-]*:/i.test(s)?s:'https://'+s);return (image?['https:']:['https:','http:','mailto:']).includes(u.protocol)&&!u.username&&!u.password?u.href:'';}catch{return '';}
}
export function calendarDate(value) {
  if(value instanceof Date){if(Number.isNaN(value.getTime()))return '';return `${value.getFullYear()}-${String(value.getMonth()+1).padStart(2,'0')}-${String(value.getDate()).padStart(2,'0')}`;}
  if(typeof value!=='string'||!/^\d{4}-\d{2}-\d{2}$/.test(value))return '';
  const d=new Date(value+'T12:00:00');return calendarDate(d)===value?value:'';
}
